import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    Sentry.init({
      app: nuxtApp.vueApp,
      dsn: 'https://99440b06088ccb2b2e838b34d2b7997a@sentry.mfuns.net/5',
      integrations: [
        Sentry.browserTracingIntegration({
          tracePropagationTargets: ['localhost', /^https:\/\/mfuns\.net/]
        }),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false
        })
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0
    })
  }
})
